<template>
<m-pageframe
    title="Engagement: Contact Requests in Alarm"
    :color="pageframe_color"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickExcelExport()"
                >
                    <v-list-item-title>Export to excel...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-layout row wrap>
        <v-flex flex-grow-0>
            <m-boolean-search-filter
                style="margin-top: 5px; margin-left: 10px;"
                label="Is Revenue Account"
                v-model="filter_is_revenue_account"
                v-on:input='doUpdate'
            />
        </v-flex>
    </v-layout>
    
    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.is_revenue_account="{ item }">
            <v-simple-checkbox
               disabled
                v-model="item.is_revenue_account"
            />
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickViewWebchatRequests(item)"
                >
                    <v-list-item-title>View webchat requests...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <br/>
    How the numbers on this screen are calculated:
    <ul
        style="margin-top: 15px"
    >
        <li>only webchat requests <b>submitted in the past 7</b> days are considered
        <ul>
            <li>contact requests created more than 7 days ago do not count</li>
            <li>contact requests not submitted via webchat don't count towards any of the figures on this page</li>
        </ul>

        <li style="margin-top: 15px">Webchat requests are "in alarm" when:</li>
        <ul>
            <li>The webchat request is still open (has not been replied to, forwarded, marked as spam or closed without a reply)</li>
            <li>An entire <b>business day</b> has passed since the contact request was submitted</li>
            <ul>
                <li>Partial days (e.g. the day a contact request was submitted) do not count</li>
            </ul>
        </ul>  
    </ul>

    <p
        style="margin-top: 15px"
    >
        A business day is:
        <ul>
            <li>A weekday</li>
            <li>That is not a federal holiday (including observed holidays) in the United States</li>
        </ul>
    </p>

    <p
        style="margin-top: 15px"
    >
        For example, imagine a webchat request submitted on Friday, October 6th at 3:30 PM.  This contact request would not be "in alarm" until 12:01 AM on Wednesday, October 11th.
        <ul>
            <li>Friday, October 6th does not count, becuase that is a partial day</li>
            <li>Saturday, October 7th does not count, it is a weekend</li>
            <li>Sunday, October 8th does not count, it is a weekend</li>
            <li>Monday, October 9th does not count, it was Columbus day</li>
            <li>Tuesday, October 10th is the first full business day</li>
            <li>So, starting at 12:01 AM on Wednesday, October 11th, the webchat request has been open for an entire business day -- raising the alarm for this contact request</li>
        </ul>
    </p>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            results: [],
            filter_is_revenue_account: true,

            headers: [
                { text: 'Organization', value: 'organization_label'},
                { text: 'Revenue Account', value: 'is_revenue_account'},
                { text: 'In Alarm', value: 'count_in_alarm'},
                { text: 'Not in Alarm', value: 'count_not_in_alarm'},
                { text: 'Total', value: 'count_total'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/admin/engagement/contact-request-alarm',
            
                'params' : {
                        'full_text': this.full_text,
                        'is_revenue_account' : this.filter_is_revenue_account,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to search contact request alarm(s)',
            });
        },

        onClickExcelExport()
        {
             this.$rc.excelExport(
                    'EXPORT: /api/v1/admin/engagement/contact-request-alarm/start-excel-export',
                    {
                    }
                );
        },

        onClickViewWebchatRequests(item)
        {
            this.$router.push({
                'name': 'search-inbox-contact-requests-without-start-inbox',
                'params' : {
                    'organization_id': item.organization_id,
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>